import { FC } from "react";
import { ButtonProps } from "./types";
import { Text } from "../../typography";

const Button: FC<ButtonProps> = ({
  props,
  children,
  background,
  color,
  className = "",
  onClick = () => {},
  style = {},
  loading = false,
}) => {
  const handleClick = (): void => {
    if (!loading) onClick();
  };

  return (
    <button
      style={{
        background,
        borderRadius: 30,
        width: 144,
        height: 35,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        ...style,
      }}
      onClick={handleClick}
      className={className}
      {...props}
    >
      <Text color={color} size={16}>
        {children || ""}
      </Text>
    </button>
  );
};

export default Button;
